var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75556 11.7333L13.0222 5.46667L11.7778 4.22222L6.75556 9.24444L4.22222 6.71111L2.97778 7.95556L6.75556 11.7333ZM1.77778 16C1.28889 16 0.870223 15.8258 0.521779 15.4773C0.173335 15.1289 -0.000591083 14.7105 1.50915e-06 14.2222V1.77778C1.50915e-06 1.28889 0.174224 0.870223 0.522668 0.521779C0.871113 0.173335 1.28948 -0.000591083 1.77778 1.50915e-06H14.2222C14.7111 1.50915e-06 15.1298 0.174224 15.4782 0.522668C15.8267 0.871113 16.0006 1.28948 16 1.77778V14.2222C16 14.7111 15.8258 15.1298 15.4773 15.4782C15.1289 15.8267 14.7105 16.0006 14.2222 16H1.77778Z",
    fill: "#FF7B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPink);
export default __webpack_public_path__ + "static/media/checked-pink.0669c6b569bc5076709ca518bf301d72.svg";
export { ForwardRef as ReactComponent };